import { getJSBasePath } from '../utils/loadJS';

const iframeManager = () => {
  let timeOut = null;
  let iframe;
  function init() {
    handleNetworkMode();
  }
  function handleNetworkMode() {
    if (
      localStorage.getItem('NETWORK_LOG_MODE') == 'true' ||
      localStorage.getItem('AUTO_ENABLE_NETWORK_LOG_MODE') == 'true'
    ) {
      loadIframe();
    }
  }

  function loadIframe() {
    const iframeEl = document.getElementById('gv_simulation_iframe');
    if (iframeEl) return;
    let basePath = getJSBasePath();
    let iframePAth = basePath + '/simulation/iframe.html';
    iframe = document.createElement('iframe');
    iframe.src = iframePAth;
    iframe.id = 'gv_simulation_iframe';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.onload = function () {
      console.log('Iframe has loaded successfully.');
      onIframeLoad();
    };
  }
  function onIframeLoad() {
    startPolling();
  }
  function startPolling() {
    clearTimeout(timeOut);
    timeOut = setTimeout(onEachPoll, 10 * 1000);
  }
  function onEachPoll() {
    try {
      let GODAVARI_DATA = window.gv2NetworksLogs || [];
      let GODAVARI_GA_DATA = window.gaNetworksLogs || [];
      if (GODAVARI_DATA || GODAVARI_GA_DATA) {
        let iframeData = {
          GODAVARI_DATA: GODAVARI_DATA,
          GODAVARI_GA_DATA: GODAVARI_GA_DATA,
          platformType: localStorage.getItem('GV_NETWORK_PLATFORM_TYPE'),
        };
        if (GODAVARI_DATA.length > 0 && GODAVARI_GA_DATA.length > 0) {
          iframeData = JSON.parse(JSON.stringify(iframeData));
        }

        iframe.contentWindow.postMessage(iframeData, '*');
      }
      startPolling();
    } catch (error) {
      console.error(error);
    }
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
};

export { iframeManager };
